import React from 'react';
import PickCharacter from './PickCharacter';
import PickStage from './PickStage';
import RemoveStage from './RemoveStage';
import RemoveCharacter from './RemoveCharacter';

// I want to Add selector for Normal and "Arcade" modes. For Arcade mode, all of the characters will be unlocked. Even the extra characters.

const Sidebar = ({ handleShowImage, numberOfPlayers, onResetRun }) => {
  return (
    <div className='sidebar'>
      <PickStage />
      <PickCharacter
        handleShowImage={handleShowImage}
        numberOfPlayers={numberOfPlayers}
      />
      <RemoveStage />
      <RemoveCharacter />
      <div className='reset-run-container'>
        <header>Reset Run</header>
        <button className='button' id='resetRunButton' onClick={onResetRun}>
          Reset
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
